<template>
  <!-- ******************* -->
  <!-- *      Modal      * -->
  <!-- ******************* -->
  <!-- This modal is for editing checks -->
  <div
    class="modal fade"
    id="editChecksDialog"
    data-backdrop="static"
    data-keyboard="false"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <form id="editChecksForm">
          <div class="modal-header">
            <!-- Close button in the upper right corner -->
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-hidden="true"
            >
              ×
            </button>

            <!-- Modal Title -->
            <h4 class="modal-title">
              <b>{{ lang.CM1000 }}</b>
            </h4>
          </div>
          <div class="modal-body">
            <!-- Accordion - hides content that is not used -->
            <div
              class="panel-group"
              id="accordionEditChecks"
              role="tablist"
              aria-multiselectable="true"
            >
              <div class="panel panel-default">
                <!-- Accordion entry 1 -->
                <div
                  class="panel-heading"
                  role="button"
                  id="headingEditChecksGeneral"
                  data-toggle="collapse"
                  data-parent="#accordionEditChecks"
                  href="#collapseEditChecksGeneral"
                  aria-expanded="true"
                  aria-controls="collapseEditChecksGeneral"
                >
                  <h4 class="panel-title">
                    <a class="collapsed">{{ lang.CM1001 }}</a>
                  </h4>
                </div>
                <div
                  id="collapseEditChecksGeneral"
                  class="panel-collapse collapse in"
                  role="tabpanel"
                  aria-labelledby="headingEditChecksGeneral"
                >
                  <div class="panel-body">
                    <div class="col-md-5">
                      <a
                        role="button"
                        class="btn btn-default btn-cb-edit-checks"
                        @click="
                          generalSettingsData.IsReadonly ||
                            toggleSetting('SurveyInstanceExternalInterface')
                        "
                        :disabled="generalSettingsData.IsReadonly"
                      >
                        <i
                          class="material-icons md-24 text-primary"
                          v-if="
                            generalSettingsData.SurveyInstanceExternalInterface >
                            0
                          "
                          >check_box</i
                        >
                        <i
                          class="material-icons md-24 text-primary"
                          v-else-if="
                            generalSettingsData.SurveyInstanceExternalInterface <
                            0
                          "
                          >indeterminate_check_box</i
                        >
                        <i class="material-icons md-24" v-else
                          >check_box_outline_blank</i
                        >
                        <span>{{ lang.CM1003 }}</span>
                      </a>
                      <a
                        role="button"
                        class="btn btn-default btn-cb-edit-checks"
                        @click="
                          generalSettingsData.IsReadonly ||
                            toggleSetting('SurveyInstanceExternalCustom')
                        "
                        :disabled="generalSettingsData.IsReadonly"
                      >
                        <i
                          class="material-icons md-24 text-primary"
                          v-if="
                            generalSettingsData.SurveyInstanceExternalCustom > 0
                          "
                          >check_box</i
                        >
                        <i
                          class="material-icons md-24 text-primary"
                          v-else-if="
                            generalSettingsData.SurveyInstanceExternalCustom < 0
                          "
                          >indeterminate_check_box</i
                        >
                        <i class="material-icons md-24" v-else
                          >check_box_outline_blank</i
                        >
                        <span>{{ lang.CM1004 }}</span>
                      </a>
                      <a
                        role="button"
                        class="btn btn-default btn-cb-edit-checks"
                        @click="
                          generalSettingsData.IsReadonly ||
                            toggleSetting('SurveyInstanceQueryTool')
                        "
                        :disabled="generalSettingsData.IsReadonly"
                      >
                        <i
                          class="material-icons md-24 text-primary"
                          v-if="generalSettingsData.SurveyInstanceQueryTool > 0"
                          >check_box</i
                        >
                        <i
                          class="material-icons md-24 text-primary"
                          v-else-if="
                            generalSettingsData.SurveyInstanceQueryTool < 0
                          "
                          >indeterminate_check_box</i
                        >
                        <i class="material-icons md-24" v-else
                          >check_box_outline_blank</i
                        >
                        <span>{{ lang.CM1005 }}</span>
                      </a>
                      <a
                        role="button"
                        class="btn btn-default btn-cb-edit-checks"
                        @click="
                          generalSettingsData.IsReadonly ||
                            toggleSetting('SurveyInstanceDashboard')
                        "
                        :disabled="generalSettingsData.IsReadonly"
                      >
                        <i
                          class="material-icons md-24 text-primary"
                          v-if="generalSettingsData.SurveyInstanceDashboard > 0"
                          >check_box</i
                        >
                        <i
                          class="material-icons md-24 text-primary"
                          v-else-if="
                            generalSettingsData.SurveyInstanceDashboard < 0
                          "
                          >indeterminate_check_box</i
                        >
                        <i class="material-icons md-24" v-else
                          >check_box_outline_blank</i
                        >
                        <span>{{ lang.CM1006 }}</span>
                      </a>
                      <a
                        role="button"
                        class="btn btn-default btn-cb-edit-checks"
                        @click="
                          generalSettingsData.IsReadonly ||
                            toggleSetting('SurveyInstanceCheckExplorer')
                        "
                        :disabled="generalSettingsData.IsReadonly"
                      >
                        <i
                          class="material-icons md-24 text-primary"
                          v-if="
                            generalSettingsData.SurveyInstanceCheckExplorer > 0
                          "
                          >check_box</i
                        >
                        <i
                          class="material-icons md-24 text-primary"
                          v-else-if="
                            generalSettingsData.SurveyInstanceCheckExplorer < 0
                          "
                          >indeterminate_check_box</i
                        >
                        <i class="material-icons md-24" v-else
                          >check_box_outline_blank</i
                        >
                        <span>{{ lang.CM1007 }}</span>
                      </a>
                      <a
                        role="button"
                        class="btn btn-default btn-cb-edit-checks"
                        @click="
                          generalSettingsData.IsReadonly ||
                            toggleSetting('SurveyInstanceAggregatedReport')
                        "
                        :disabled="generalSettingsData.IsReadonly"
                      >
                        <i
                          class="material-icons md-24 text-primary"
                          v-if="
                            generalSettingsData.SurveyInstanceAggregatedReport >
                            0
                          "
                          >check_box</i
                        >
                        <i
                          class="material-icons md-24 text-primary"
                          v-else-if="
                            generalSettingsData.SurveyInstanceAggregatedReport <
                            0
                          "
                          >indeterminate_check_box</i
                        >
                        <i class="material-icons md-24" v-else
                          >check_box_outline_blank</i
                        >
                        <span>{{ lang.CM1008 }}</span>
                      </a>
                      <a
                        role="button"
                        class="btn btn-default btn-cb-edit-checks"
                        @click="
                          generalSettingsData.IsReadonly ||
                            toggleSetting('SurveyInstanceRawDataExports')
                        "
                        :disabled="generalSettingsData.IsReadonly"
                      >
                        <i
                          class="material-icons md-24 text-primary"
                          v-if="
                            generalSettingsData.SurveyInstanceRawDataExports > 0
                          "
                          >check_box</i
                        >
                        <i
                          class="material-icons md-24 text-primary"
                          v-else-if="
                            generalSettingsData.SurveyInstanceRawDataExports < 0
                          "
                          >indeterminate_check_box</i
                        >
                        <i class="material-icons md-24" v-else
                          >check_box_outline_blank</i
                        >
                        <span>{{ lang.CM1009 }}</span>
                      </a>
                      <a
                        role="button"
                        class="btn btn-default btn-cb-edit-checks"
                        @click="
                          generalSettingsData.IsReadonly ||
                            toggleSetting('SurveyInstanceFrequencies')
                        "
                        :disabled="generalSettingsData.IsReadonly"
                      >
                        <i
                          class="material-icons md-24 text-primary"
                          v-if="
                            generalSettingsData.SurveyInstanceFrequencies > 0
                          "
                          >check_box</i
                        >
                        <i
                          class="material-icons md-24 text-primary"
                          v-else-if="
                            generalSettingsData.SurveyInstanceFrequencies < 0
                          "
                          >indeterminate_check_box</i
                        >
                        <i class="material-icons md-24" v-else
                          >check_box_outline_blank</i
                        >
                        <span>{{ lang.CM1010 }}</span>
                      </a>
                      <a
                        role="button"
                        class="btn btn-default btn-cb-edit-checks"
                        @click="
                          generalSettingsData.IsReadonly ||
                            toggleSetting('SurveyInstanceMediaExplorer')
                        "
                        :disabled="generalSettingsData.IsReadonly"
                      >
                        <i
                          class="material-icons md-24 text-primary"
                          v-if="
                            generalSettingsData.SurveyInstanceMediaExplorer > 0
                          "
                          >check_box</i
                        >
                        <i
                          class="material-icons md-24 text-primary"
                          v-else-if="
                            generalSettingsData.SurveyInstanceMediaExplorer < 0
                          "
                          >indeterminate_check_box</i
                        >
                        <i class="material-icons md-24" v-else
                          >check_box_outline_blank</i
                        >
                        <span>{{ lang.CM1011 }}</span>
                      </a>
                    </div>

                    <div class="col-md-7">
                      <div class="form-group fg-general-settings-input">
                        <label
                          for="inputCustomReportingDateCheckMgmtEdit"
                          class="col-md-4 control-label"
                          >{{ lang.CM1013 }}</label
                        >
                        <div
                          class="col-md-8"
                          @click="
                            globals.toggleFlatpickr(
                              'inputCustomReportingDateCheckMgmtEdit'
                            )
                          "
                        >
                          <input
                            type="text"
                            class="form-control"
                            id="inputCustomReportingDateCheckMgmtEdit"
                            v-model="
                              generalSettingsData.SurveyInstanceCustomReportingDate
                            "
                            :disabled="generalSettingsData.IsReadonly"
                          />
                        </div>
                      </div>
                      <div
                        class="form-group fg-general-settings-input"
                        v-if="languageStringsReceived && !feature.isAudiTarget"
                      >
                        <label
                          for="checkManagementEditModalSelectSurveyInstanceType"
                          class="col-md-4 control-label"
                          >{{ lang.CM1036 }}</label
                        >
                        <div class="col-md-8">
                          <select2
                            class="form-control"
                            id="checkManagementEditModalSelectSurveyInstanceType"
                            v-model="generalSettingsData.SurveyInstanceType"
                            @change="surveyInstanceTypeChanged"
                          >
                            <option value="FO">{{ lang.CM1037 }}</option>
                            <option value="MA">{{ lang.CM1038 }}</option>
                            <option value="AG">{{ lang.CM1039 }}</option>
                          </select2>
                        </div>
                      </div>
                      <div
                        class="form-group fg-general-settings-input"
                        v-if="
                          generalSettingsData.SurveyInstanceType === 'FO' ||
                          generalSettingsData.SurveyInstanceType === 'MA'
                        "
                      >
                        <label
                          for="checkManagementEditModalSelectUser"
                          class="col-md-4 control-label"
                          >{{ lang.CM1015 }}</label
                        >
                        <div class="col-md-8">
                          <select2
                            class="form-control"
                            id="checkManagementEditModalSelectUser"
                            v-model="
                              generalSettingsData.SurveyInstanceAssignedShopperGuid
                            "
                            @change="
                              delete generalSettingsData.SurveyInstanceAssignedLocalAgencyGuid,
                                delete generalSettingsData.SurveyInstanceAssignedLeadAgencyGuid
                            "
                            :placeholder="' '"
                            :allowClear="true"
                            :disabled="generalSettingsData.IsReadonly"
                          >
                            <option></option>
                            <option
                              v-for="(user, guid) in dataLists.shopperList"
                              :key="guid"
                              :value="guid"
                            >
                              {{ user }}
                            </option>
                          </select2>
                        </div>
                      </div>
                      <template
                        v-if="generalSettingsData.SurveyInstanceType === 'AG'"
                      >
                        <template
                          v-if="
                            feature.isAudiTarget &&
                            feature.isEnabled('leadAgencies')
                          "
                        >
                          <div class="form-group fg-general-settings-input">
                            <label
                              for="checkManagementEditModalSelectLeadAgency"
                              class="col-md-4 control-label"
                              >{{ lang.CM1066 }}</label
                            >
                            <div class="col-md-8">
                              <select2
                                class="form-control"
                                id="checkManagementEditModalSelectLeadAgency"
                                ref="checkEditSelectLeadAgency"
                                v-model="
                                  generalSettingsData.SurveyInstanceAssignedLeadAgencyGuid
                                "
                                @change="
                                  delete generalSettingsData.SurveyInstanceAssignedShopperGuid,
                                    delete generalSettingsData.SurveyInstanceAssignedLocalAgencyGuid
                                "
                                :disabled="
                                  generalSettingsData.IsReadonly ||
                                  (feature.isAudiTarget &&
                                    generalSettingsData.MaxSurveyInstanceStatusId >
                                      50)
                                "
                              >
                                <option
                                  v-for="agency in leadAgencies"
                                  :key="agency.AgencyGuid"
                                  :value="agency.AgencyGuid"
                                >
                                  {{ agency.AgencyName }}
                                </option>
                              </select2>
                            </div>
                          </div>
                          <div
                            class="form-group fg-general-settings-input"
                            v-if="!globals.currentUserInfo.IsAudiUser"
                          >
                            <label
                              for="checkManagementEditModalSelectLocalAgency"
                              class="col-md-4 control-label"
                              >{{ lang.CM1067 }}</label
                            >
                            <div class="col-md-8">
                              <select2
                                class="form-control"
                                id="checkManagementEditModalSelectLocalAgency"
                                ref="checkEditSelectLocalAgency"
                                v-model="
                                  generalSettingsData.SurveyInstanceAssignedLocalAgencyGuid
                                "
                                @change="
                                  delete generalSettingsData.SurveyInstanceAssignedShopperGuid
                                "
                                :placeholder="' '"
                                :allowClear="true"
                                :disabled="generalSettingsData.IsReadonly"
                              >
                                <option></option>
                                <option
                                  v-for="agency in localAgencies"
                                  :key="agency.AgencyGuid"
                                  :value="agency.AgencyGuid"
                                >
                                  {{ agency.AgencyName }}
                                </option>
                              </select2>
                            </div>
                          </div>
                        </template>
                        <div
                          class="form-group fg-general-settings-input"
                          v-else
                        >
                          <label
                            for="checkManagementEditModalSelectAgency"
                            class="col-md-4 control-label"
                            >{{ lang.CM1016 }}</label
                          >
                          <div class="col-md-8">
                            <select2
                              class="form-control"
                              id="checkManagementEditModalSelectAgency"
                              v-model="
                                generalSettingsData.SurveyInstanceAssignedLocalAgencyGuid
                              "
                              @change="
                                delete generalSettingsData.SurveyInstanceAssignedShopperGuid
                              "
                              :placeholder="' '"
                              :allowClear="true"
                              :disabled="generalSettingsData.IsReadonly"
                            >
                              <option></option>
                              <option
                                v-for="agency in dataLists.agencyList"
                                :key="agency.AgencyGuid"
                                :value="agency.AgencyGuid"
                              >
                                {{ agency.AgencyName }}
                              </option>
                            </select2>
                          </div>
                        </div>
                      </template>
                      <div
                        class="form-group fg-general-settings-input"
                        v-if="projectSelected"
                      >
                        <label
                          for="checkManagementEditModalSelectWave"
                          class="col-md-4 control-label"
                          >{{ lang.CM1028 }}</label
                        >
                        <div class="col-md-8">
                          <select2
                            class="form-control"
                            id="checkManagementEditModalSelectWave"
                            v-model="generalSettingsData.SurveyInstanceWaveGuid"
                            @change="
                              generalSettingsData.SurveyInstanceScenarioGuid =
                                ''
                            "
                            :placeholder="' '"
                            :allowClear="true"
                            :disabled="generalSettingsData.IsReadonly"
                          >
                            <option></option>
                            <option
                              v-for="wave in wavesOfProject"
                              :key="wave.WaveGuid"
                              :value="wave.WaveGuid"
                            >
                              {{ wave.WaveName }}
                            </option>
                          </select2>
                        </div>
                      </div>
                      <div
                        class="form-group fg-general-settings-input"
                        v-if="projectSelected"
                      >
                        <label
                          for="checkManagementEditModalSelectScenario"
                          class="col-md-4 control-label"
                          >{{ lang.CM1014 }}</label
                        >
                        <div class="col-md-8">
                          <select2
                            class="form-control"
                            id="checkManagementEditModalSelectScenario"
                            v-model="
                              generalSettingsData.SurveyInstanceScenarioGuid
                            "
                            :disabled="
                              generalSettingsData.IsReadonly ||
                              !generalSettingsData.SurveyInstanceWaveGuid
                            "
                            :placeholder="' '"
                            :allowClear="true"
                          >
                            <option></option>
                            <option
                              v-for="scenario in scenariosOfWave"
                              :key="scenario.ScenarioGuid"
                              :value="scenario.ScenarioGuid"
                            >
                              {{ scenario.ScenarioName }}
                            </option>
                          </select2>
                        </div>
                      </div>
                      <div
                        class="form-group fg-general-settings-input"
                        v-if="projectSelected"
                      >
                        <label
                          for="checkManagementEditModalSelectLocation"
                          class="col-md-4 control-label"
                          >{{ lang.CM1029 }}</label
                        >
                        <div class="col-md-8">
                          <select2
                            class="form-control"
                            id="checkManagementEditModalSelectLocation"
                            v-model="
                              generalSettingsData.SurveyInstanceLocationGuid
                            "
                            @change="selectedLocationChanged()"
                            :disabled="
                              generalSettingsData.IsReadonly ||
                              generalSettingsData.MaxSurveyInstanceStatusId >
                                190 ||
                              generalSettingsData.SurveyInstanceLocationGuid ==
                                '-1'
                            "
                          >
                            <option
                              v-for="location in locationsOfSelectedClient"
                              :key="location.LocationGuid"
                              :value="location.LocationGuid"
                            >
                              ({{ location.LocationStoreId }})
                              {{ location.LocationAddress }}
                            </option>
                          </select2>
                        </div>
                      </div>
                      <div
                        class="form-group fg-general-settings-input"
                        v-if="
                          feature.isEnabled('briefingAndSurveyDocs') &&
                          selectedProject
                        "
                      >
                        <label
                          for="checkManagementEditModalSelectBriefing"
                          class="col-md-4 control-label"
                          >{{ lang.CM1034 }}</label
                        >
                        <div class="col-md-8">
                          <select2
                            class="form-control"
                            id="checkManagementEditModalSelectBriefing"
                            v-model="generalSettingsData.BriefingDownloadGuid"
                            :placeholder="' '"
                            :allowClear="true"
                            :disabled="
                              generalSettingsData.IsReadonly ||
                              generalSettingsData.MaxSurveyInstanceStatusId >
                                190 ||
                              generalSettingsData.BriefingDownloadGuid === '-1'
                            "
                          >
                            <option
                              v-for="briefing in briefingAttachments"
                              :key="briefing.DownloadId"
                              :value="briefing.DownloadId"
                            >
                              {{ briefing.FileName }}
                            </option>
                          </select2>
                        </div>
                      </div>
                      <div
                        class="form-group fg-general-settings-input"
                        v-if="
                          feature.isEnabled('briefingAndSurveyDocs') &&
                          selectedProject
                        "
                      >
                        <label
                          for="checkManagementEditModalSelectSurvey"
                          class="col-md-4 control-label"
                          >{{ lang.CM1035 }}</label
                        >
                        <div class="col-md-8">
                          <select2
                            class="form-control"
                            id="checkManagementEditModalSelectSurvey"
                            v-model="generalSettingsData.SurveyDownloadGuid"
                            :placeholder="' '"
                            :allowClear="true"
                            :disabled="
                              generalSettingsData.IsReadonly ||
                              generalSettingsData.MaxSurveyInstanceStatusId >
                                190 ||
                              generalSettingsData.SurveyDownloadGuid === '-1'
                            "
                          >
                            <option
                              v-for="survey in surveyAttachments"
                              :key="survey.DownloadId"
                              :value="survey.DownloadId"
                            >
                              {{ survey.FileName }}
                            </option>
                          </select2>
                        </div>
                      </div>
                      <div class="form-group fg-general-settings-input">
                        <label
                          for="inputCheckEditSurveyInstanceInfo"
                          class="col-md-4 control-label"
                          >{{ lang.CM1056 }}</label
                        >
                        <div class="col-md-8">
                          <input
                            type="text"
                            class="form-control"
                            maxlength="50"
                            id="inputCheckEditSurveyInstanceInfo"
                            v-model="generalSettingsData.SurveyInstanceInfo"
                          />
                        </div>
                      </div>

                      <div
                        v-show="generalSettingsData.SurveyInstanceType === 'FO'"
                      >
                        <div class="form-group fg-general-settings-input">
                          <label
                            for="inputCheckEditStartDate"
                            class="col-md-4 control-label"
                            >{{ lang.CM1040 }}</label
                          >
                          <div
                            class="col-md-8"
                            @click="
                              globals.toggleFlatpickr('inputCheckEditStartDate')
                            "
                          >
                            <input
                              type="text"
                              class="form-control"
                              id="inputCheckEditStartDate"
                              v-model="generalSettingsData.SurveyInstanceSince"
                            />
                          </div>
                        </div>
                        <div class="form-group fg-general-settings-input">
                          <label
                            for="inputCheckEditEndDate"
                            class="col-md-4 control-label"
                            >{{ lang.CM1041 }}</label
                          >
                          <div
                            class="col-md-8"
                            @click="
                              globals.toggleFlatpickr('inputCheckEditEndDate')
                            "
                          >
                            <input
                              type="text"
                              class="form-control"
                              id="inputCheckEditEndDate"
                              v-model="generalSettingsData.SurveyInstanceUntil"
                            />
                          </div>
                        </div>
                        <div class="form-group fg-general-settings-input">
                          <label
                            for="selectCheckEditSurveyInstanceSkillLevel"
                            class="col-md-4 control-label"
                            >{{ lang.CM1057 }}</label
                          >
                          <div class="col-md-8">
                            <select
                              class="form-control"
                              id="selectCheckEditSurveyInstanceSkillLevel"
                              v-model.number="
                                generalSettingsData.SurveyInstanceSkillLevel
                              "
                            >
                              <option :value="undefined">
                                {{ lang.CM1061 }}
                                <span
                                  v-if="
                                    generalSettingsData.SurveySkillLevel > 0
                                  "
                                  >({{
                                    generalSettingsData.SurveySkillLevel
                                  }})</span
                                >
                              </option>
                              <option v-for="i in 5" :key="i">{{ i }}</option>
                            </select>
                          </div>
                          <b-tooltip
                            target="selectCheckEditSurveyInstanceSkillLevel"
                            :delay="globals.tooltipDelay"
                            placement="right"
                            boundary="viewport"
                          >
                            1 &rarr; {{ lang.CM1058 }}
                            <br />
                            <br />...
                            <br />
                            <br />
                            5 &rarr; {{ lang.CM1059 }}
                          </b-tooltip>
                        </div>
                        <div class="form-group fg-general-settings-input">
                          <label class="col-md-4 control-label"></label>
                          <a
                            role="button"
                            class="btn btn-default btn-state"
                            @click="
                              generalSettingsData.IsReadonly ||
                                toggleSetting('OnlineState')
                            "
                            :disabled="generalSettingsData.IsReadonly"
                          >
                            <i
                              class="material-icons md-24 text-primary"
                              v-if="generalSettingsData.OnlineState > 0"
                              >check_box</i
                            >
                            <i
                              class="material-icons md-24 text-primary"
                              v-else-if="generalSettingsData.OnlineState < 0"
                              >indeterminate_check_box</i
                            >
                            <i class="material-icons md-24" v-else
                              >check_box_outline_blank</i
                            >
                            <span>{{ lang.CM1042 }}</span>
                          </a>
                        </div>
                        <div class="form-group fg-general-settings-input">
                          <label class="col-md-4 control-label"></label>
                          <a
                            role="button"
                            class="btn btn-default btn-state"
                            @click="
                              generalSettingsData.IsReadonly ||
                                toggleSetting('LocationFree')
                            "
                            :disabled="generalSettingsData.IsReadonly"
                          >
                            <i
                              class="material-icons md-24 text-primary"
                              v-if="generalSettingsData.LocationFree > 0"
                              >check_box</i
                            >
                            <i
                              class="material-icons md-24 text-primary"
                              v-else-if="generalSettingsData.LocationFree < 0"
                              >indeterminate_check_box</i
                            >
                            <i class="material-icons md-24" v-else
                              >check_box_outline_blank</i
                            >
                            <span>{{ lang.CM1043 }}</span>
                          </a>
                        </div>
                        <div class="form-group fg-general-settings-input">
                          <label class="col-md-4 control-label"></label>
                          <button
                            type="button"
                            class="btn btn-raised"
                            @click="openHtmlEditor()"
                            :disabled="generalSettingsData.IsReadonly"
                          >
                            {{ lang.CM1044 }}
                          </button>
                        </div>
                        <div class="form-group fg-general-settings-input">
                          <label class="col-md-4 control-label"></label>
                          <button
                            type="button"
                            class="btn btn-raised pull-left"
                            @click="openShopperFilterModal()"
                            :disabled="generalSettingsData.IsReadonly"
                          >
                            {{ lang.CM1053 }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Accordion entry 2 -->
                <div
                  class="panel-heading"
                  role="button"
                  id="headingEditChecksSpecific"
                  data-toggle="collapse"
                  data-parent="#accordionEditChecks"
                  href="#collapseEditChecksSpecific"
                  aria-expanded="false"
                  aria-controls="collapseEditChecksSpecific"
                  v-if="
                    globals.isAccessAllowed(
                      'LoopOp_SurveyInstancesAnswers_Read'
                    ) && !generalSettingsData.IsReadonly
                  "
                >
                  <h4 class="panel-title">
                    <a class="collapsed">{{ lang.CM1017 }}</a>
                  </h4>
                </div>
                <div
                  id="collapseEditChecksSpecific"
                  class="panel-collapse collapse"
                  role="tabpanel"
                  aria-labelledby="headingEditChecksSpecific"
                  v-if="
                    globals.isAccessAllowed(
                      'LoopOp_SurveyInstancesAnswers_Read'
                    ) && !generalSettingsData.IsReadonly
                  "
                >
                  <div class="panel-body" style="padding: 15px">
                    <div class="col-md-4" id="checkListContainer">
                      <table class="table table-striped table-hover main-table">
                        <thead>
                          <tr>
                            <th class="text-center">{{ lang.CM1018 }}</th>
                          </tr>
                        </thead>
                        <tbody
                          class="main-table-scrollbar"
                          id="check-list-table"
                        >
                          <tr
                            role="button"
                            v-for="(check,
                            key) in specificSettingsData.dataList"
                            :key="key"
                            @click="specificSettingsData.selectedCheck = check"
                            :class="{
                              info:
                                specificSettingsData.selectedCheck
                                  .SurveyInstanceGuid ===
                                check.SurveyInstanceGuid,
                            }"
                          >
                            <td>{{ check.SurveyInstanceId }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div class="col-md-8">
                      <div
                        class="shopper-info"
                        v-if="
                          specificSettingsData.selectedCheck.ApprovedShopper
                        "
                      >
                        <b>{{ lang.CM1068 }}:</b>
                        {{
                          specificSettingsData.selectedCheck.ApprovedShopper
                            .DisplayName
                        }}
                        <div id="approvedShopperDetailsContainer">
                          {{ lang.CM1069 }} ({{ lang.CM1070 }}):
                          {{
                            specificSettingsData.selectedCheck.ApprovedShopper
                              .ShopperAge
                          }}
                          ({{
                            specificSettingsData.selectedCheck.ApprovedShopper
                              .Gender
                          }})
                          <br />
                          {{ lang.CM1071 }}:
                          {{
                            specificSettingsData.selectedCheck.ApprovedShopper
                              .ShopperCar
                          }}
                          <br />
                          {{ lang.CM1072 }}:
                          {{
                            specificSettingsData.selectedCheck.ApprovedShopper
                              .CarSegmentName
                          }}
                          <br />
                          {{ lang.CM1073 }}:
                          {{
                            specificSettingsData.selectedCheck.ApprovedShopper
                              .CarModelName
                          }}
                        </div>
                      </div>
                      <div class="form-group">
                        <label
                          for="inputDateOfVisitCheckMgmtEdit"
                          class="col-md-4 control-label"
                          >{{ lang.CM1019 }}</label
                        >
                        <div
                          class="col-md-8"
                          @click="
                            globals.toggleFlatpickr(
                              'inputDateOfVisitCheckMgmtEdit'
                            )
                          "
                        >
                          <input
                            type="text"
                            class="form-control"
                            id="inputDateOfVisitCheckMgmtEdit"
                            v-model="
                              specificSettingsData.selectedCheck
                                .SurveyInstanceAnswerDateOfVisit
                            "
                            :disabled="
                              !globals.isAccessAllowed(
                                'LoopOp_SurveyInstancesAnswers_Update'
                              )
                            "
                          />
                        </div>
                      </div>
                      <div class="form-group">
                        <label
                          for="inputTimeInCheckMgmtEdit"
                          class="col-md-4 control-label"
                          >{{ lang.CM1020 }}</label
                        >
                        <div
                          class="col-md-8"
                          @click="
                            globals.toggleFlatpickr('inputTimeInCheckMgmtEdit')
                          "
                        >
                          <input
                            type="text"
                            class="form-control"
                            id="inputTimeInCheckMgmtEdit"
                            v-model="
                              specificSettingsData.selectedCheck
                                .SurveyInstanceAnswerTimeIn
                            "
                            :disabled="
                              !globals.isAccessAllowed(
                                'LoopOp_SurveyInstancesAnswers_Update'
                              )
                            "
                          />
                        </div>
                      </div>
                      <div class="form-group">
                        <label
                          for="inputTimeOutCheckMgmtEdit"
                          class="col-md-4 control-label"
                          >{{ lang.CM1021 }}</label
                        >
                        <div
                          class="col-md-8"
                          @click="
                            globals.toggleFlatpickr('inputTimeOutCheckMgmtEdit')
                          "
                        >
                          <input
                            type="text"
                            class="form-control"
                            id="inputTimeOutCheckMgmtEdit"
                            v-model="
                              specificSettingsData.selectedCheck
                                .SurveyInstanceAnswerTimeOut
                            "
                            :disabled="
                              !globals.isAccessAllowed(
                                'LoopOp_SurveyInstancesAnswers_Update'
                              )
                            "
                          />
                        </div>
                      </div>
                      <div class="form-group">
                        <label
                          for="inputMemoShopper"
                          class="col-md-4 control-label"
                          >{{ lang.CM1022 }}</label
                        >
                        <div class="col-md-8">
                          <textarea
                            class="form-control"
                            rows="4"
                            id="inputMemoShopper"
                            v-model="
                              specificSettingsData.selectedCheck
                                .SurveyInstanceAnswerMemoShopper
                            "
                            :disabled="
                              !globals.isAccessAllowed(
                                'LoopOp_SurveyInstancesAnswers_Update'
                              )
                            "
                          ></textarea>
                        </div>
                      </div>
                      <div class="form-group">
                        <label
                          for="inputMemoAgency"
                          class="col-md-4 control-label"
                          >{{ lang.CM1023 }}</label
                        >
                        <div class="col-md-8">
                          <textarea
                            class="form-control"
                            rows="4"
                            id="inputMemoAgency"
                            v-model="
                              specificSettingsData.selectedCheck
                                .SurveyInstanceAnswerMemoAgency
                            "
                            :disabled="
                              !globals.isAccessAllowed(
                                'LoopOp_SurveyInstancesAnswers_Update'
                              )
                            "
                          ></textarea>
                        </div>
                      </div>
                      <div class="form-group" v-if="!feature.isAudiTarget">
                        <label
                          for="inputMemoMSM"
                          class="col-md-4 control-label"
                          >{{ lang.CM1024 }}</label
                        >
                        <div class="col-md-8">
                          <textarea
                            class="form-control"
                            rows="4"
                            id="inputMemoMSM"
                            v-model="
                              specificSettingsData.selectedCheck
                                .SurveyInstanceAnswerMemoMSM
                            "
                            :disabled="
                              !globals.isAccessAllowed(
                                'LoopOp_SurveyInstancesAnswers_Update'
                              )
                            "
                          ></textarea>
                        </div>
                      </div>
                      <div class="form-group">
                        <label
                          for="inputEditSurveyInstanceNote"
                          class="col-md-4 control-label"
                          >{{ lang.CM1052 }}</label
                        >
                        <div class="col-md-8">
                          <textarea
                            class="form-control"
                            rows="4"
                            maxlength="1000"
                            id="inputEditSurveyInstanceNote"
                            v-model="
                              specificSettingsData.selectedCheck
                                .SurveyInstanceNote
                            "
                            :disabled="
                              !globals.isAccessAllowed(
                                'LoopOp_SurveyInstancesAnswers_Update'
                              )
                            "
                          ></textarea>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <!-- Add modal buttons here -->
            <button
              type="button"
              class="btn btn-raised btn-default"
              data-dismiss="modal"
            >
              {{ lang.CM1025 }}
            </button>
            <button
              type="button"
              class="btn btn-raised dialog-btn-primary"
              @click="saveEditCheckDialogData()"
              :disabled="
                !globals.isAccessAllowed(
                  'LoopOp_SurveyInstancesProperties_Update'
                ) || !generalSettingsData.SurveyInstanceScenarioGuid
              "
            >
              {{ lang.CM1026 }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Select2 from "../Tools/Select2";

export default {
  name: "CheckManagementEditModal",
  components: {
    Select2,
  },
  mounted() {
    if (this.globals.selectedLanguage) {
      this.languageStringsReceived = false;
      this.globals.getLanguageStrings(this, () => {
        this.languageStringsReceived = true;
      });
    }

    $("#editChecksDialog").on("hidden.bs.modal", (e) => {
      this.$emit("dialogClosed");
    });

    if (this.feature.isAudiTarget && this.feature.isEnabled("leadAgencies")) {
      this.globals.getAgencyTypeList((data) => {
        this.agencyTypeList = data;
      });
    }
  },
  computed: {
    leadAgencyGuid() {
      if (this.agencyTypeList.length < 1) return "";
      let leadAgency = _.find(
        this.agencyTypeList,
        (at) => at.AgencyTypeName === "Lead"
      );
      return leadAgency ? leadAgency.AgencyTypeGuid : "";
    },
    leadAgencies() {
      if (!this.leadAgencyGuid) return [];
      return this.dataLists.agencyList.filter(
        (a) => a.AgencyTypeGuid === this.leadAgencyGuid
      );
    },
    localAgencies() {
      if (
        !this.generalSettingsData.SurveyInstanceAssignedLeadAgencyGuid ||
        this.leadAgencies.length < 1
      )
        return [];

      let lead = this.leadAgencies.find(
        (a) =>
          a.AgencyGuid ===
          this.generalSettingsData.SurveyInstanceAssignedLeadAgencyGuid
      );
      if (this.$refs.checkEditSelectLocalAgency)
        this.$refs.checkEditSelectLocalAgency.updateValue();
      return lead && lead.ChildAgencies ? lead.ChildAgencies : [];
    },
  },
  methods: {
    convertScenarioList() {
      this.scenarioList = [];
      for (let i = 0; i < this.dataLists.scenarioList.length; i++) {
        this.scenarioList = _.union(
          this.scenarioList,
          this.dataLists.scenarioList[i].Scenarios
        );
      }
    },
    openShopperFilterModal() {
      this.globals.$emit("openShopperFilterModal");
      this.globals.$emit("sendDataToShopperFilterModal", this.shopperFilter);
      if (
        !this.$multipleCheckFilterMessageShown &&
        this.selectedChecks.length > 1
      ) {
        this.$multipleCheckFilterMessageShown = true;
        setTimeout(() => {
          this.globals.$emit("openGlobalNotificationDialog", {
            initiator: "CheckManagementEditModalOpenShopperFilter",
            notificationTitle: this.lang.CM1062,
            closeButtonText: this.lang.CM1063,
            htmlText: `<p>${this.lang.CM1064}<br><br>${this.lang.CM1065}</p>`,
          });
        }, 200);
      }
    },
    toggleSetting(setting) {
      if (this.generalSettingsData[setting] > 0)
        this.generalSettingsData[setting] = 0;
      else this.generalSettingsData[setting] = 1;
      this.$forceUpdate();
    },
    surveyInstanceTypeChanged(value) {
      delete this.generalSettingsData.SurveyInstanceAssignedLocalAgencyGuid;
      delete this.generalSettingsData.SurveyInstanceAssignedShopperGuid;

      if (value === "FO") {
        if (typeof this.generalSettingsData.LocationFree !== "number")
          this.generalSettingsData.LocationFree = 0;
        if (typeof this.generalSettingsData.OnlineState !== "number")
          this.generalSettingsData.OnlineState = 0;
      }
    },
    // Fills the editCheck dialog with data, depending on the dialog mode.
    openEditChecksDialog() {
      this.globals.$on("getDataFromShopperFilterModal", (data) => {
        if (_.isEqual(this.shopperFilter, data)) return;
        this.shopperFilter = data;
        this.shopperFilterDataDirty = true;
      });
      if (this.$clientChanged) {
        this.getLocationsOfSelectedClient();
        delete this.$clientChanged;
      }
      this.convertScenarioList();
      this.getWavesOfProject();
      this.getProjectAttachments();

      this.getCheckSpecificData();

      this.checkData = { Surveys: [] };
      $.ajax({
        method: "POST",
        url: "api/SurveyInstances/Properties?include=" + this.includeChecks,
        data: JSON.stringify(this.selectedCheckIds),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: (data) => {
          if (data.Error) {
            this.globals.showErrorSnackbar(data.Error);
            this.$emit("dialogClosed");
          } else {
            this.generalSettingsData = data;
            this.previousLocationGuid = data.SurveyInstanceLocationGuid;
            this.getShopperFilterObject();

            if (data.SurveyInstanceDescription === "-1") {
              this.generalSettingsData.SurveyInstanceDescription = "";
              this.surveyInstanceDescriptionMixed = true;
            }
            if (data.SurveyInstanceInfo === "-1") {
              this.generalSettingsData.SurveyInstanceInfo = "";
              this.surveyInstanceInfoMixed = true;
            }

            this.$nextTick(() => {
              $("#checkManagementEditModalSelectAgency").val(
                this.generalSettingsData.SurveyInstanceAssignedLocalAgencyGuid
              );
              $("#checkManagementEditModalSelectUser").val(
                this.generalSettingsData.SurveyInstanceAssignedShopperGuid
              );

              let waveBackup = this.generalSettingsData.SurveyInstanceWaveGuid;
              let scenarioBackup = this.generalSettingsData
                .SurveyInstanceScenarioGuid;
              $("#checkManagementEditModalSelectWave").val(
                this.generalSettingsData.SurveyInstanceWaveGuid
              );
              $("#checkManagementEditModalSelectWave").trigger("change");
              this.$nextTick(() => {
                $("#checkManagementEditModalSelectScenario").val(
                  scenarioBackup
                );
                $("#checkManagementEditModalSelectScenario").trigger("change");
                this.generalSettingsData.SurveyInstanceWaveGuid = waveBackup;
                this.generalSettingsData.SurveyInstanceScenarioGuid = scenarioBackup;
              });

              $("#checkManagementEditModalSelectLocation").val(
                this.generalSettingsData.SurveyInstanceLocationGuid
              );

              if (this.$refs.checkEditSelectLeadAgency)
                this.$refs.checkEditSelectLeadAgency.updateValue();

              this.fpCustomReportingDate = flatpickr(
                "#inputCustomReportingDateCheckMgmtEdit",
                this.globals.flatpickrDateConfig
              );
              this.fpBegin = flatpickr(
                "#inputCheckEditStartDate",
                this.globals.flatpickrDateConfig
              );
              this.fpEnd = flatpickr(
                "#inputCheckEditEndDate",
                this.globals.flatpickrDateConfig
              );

              if (data.SurveyInstanceCustomReportingDate != "-1")
                this.fpCustomReportingDate.setDate(
                  this.generalSettingsData.SurveyInstanceCustomReportingDate,
                  true
                );
              if (data.SurveyInstanceSince != "-1")
                this.fpBegin.setDate(
                  this.generalSettingsData.SurveyInstanceSince,
                  true
                );
              if (data.SurveyInstanceUntil != "-1")
                this.fpEnd.setDate(
                  this.generalSettingsData.SurveyInstanceUntil,
                  true
                );

              if (!this.generalSettingsData.BriefingDownloadGuid)
                this.generalSettingsData.BriefingDownloadGuid = "";
              if (!this.generalSettingsData.SurveyDownloadGuid)
                this.generalSettingsData.SurveyDownloadGuid = "";
            });

            $("#editChecksDialog").modal("show");
            this.globals.$off("getDataFromHtmlEditorModal");
            this.globals.$on("getDataFromHtmlEditorModal", (data) => {
              this.generalSettingsData.SurveyInstanceDescription = data;
            });
          }
        },
        error: () => {
          console.error("Check data access failed in openEditChecksDialog()");
          this.globals.showErrorSnackbar(this.lang.CM1045);
          this.$emit("dialogClosed");
        },
      });
    },
    // Closes the editChecksDialog
    closeEditChecksDialog() {
      this.globals.$off("getDataFromShopperFilterModal");
      if (this.fpCustomReportingDate) this.fpCustomReportingDate.destroy();
      if (this.fpDateOfVisit) this.fpDateOfVisit.destroy();
      if (this.fpTimeIn) this.fpTimeIn.destroy();
      if (this.fpTimeOut) this.fpTimeOut.destroy();
      if (this.fpBegin) this.fpBegin.destroy();
      if (this.fpEnd) this.fpEnd.destroy();
      $("#editChecksDialog").modal("hide");
    },
    getShopperFilterObject() {
      if (
        this.generalSettingsData.SurveyInstanceType !== "FO" ||
        this.selectedChecks.length > 1
      ) {
        this.shopperFilter = {};
        this.shopperFilterDataDirty = false;
        return;
      }

      let url = `api/SurveyInstances/ShopperFilter/${this.selectedChecks[0]}`;
      $.ajax({
        method: "GET",
        url: url,
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: (data) => {
          this.shopperFilter =
            data && data.ShopperFilter ? data.ShopperFilter : {};
          this.shopperFilterDataDirty = false;
        },
        error: () => {
          console.error("Error on GET in getShopperFilterObject()");
          this.globals.showErrorSnackbar(this.lang.CM1054);
          this.$emit("dialogClosed");
        },
      });
    },
    saveShopperFilterObject() {
      if (!this.shopperFilterDataDirty) return;
      let url = `api/SurveyInstances/ShopperFilter`;
      let sendData = {
        SurveyInstanceGuids: this.selectedChecks,
        ShopperFilter: this.shopperFilter,
      };

      $.ajax({
        method: "PUT",
        url: url,
        data: JSON.stringify(sendData),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: (data) => {
          this.shopperFilterDataDirty = false;
        },
        error: () => {
          console.error("Error on PUT in saveShopperFilterObject()");
          this.globals.showErrorSnackbar(this.lang.CM1055);
        },
      });
    },
    // Sends the data from editCheck dialog to the server to store it in the database
    saveEditCheckDialogData() {
      this.saveShopperFilterObject();
      this.saveCheckSpecificData();

      if (
        this.generalSettingsData.SurveyInstanceType === "AG" &&
        !this.generalSettingsData.SurveyInstanceAssignedLocalAgencyGuid &&
        !this.feature.isAudiTarget
      ) {
        this.globals.showErrorSnackbar(this.lang.CM1046);
        return;
      }
      if (
        this.generalSettingsData.SurveyInstanceType === "MA" &&
        !this.generalSettingsData.SurveyInstanceAssignedShopperGuid
      ) {
        this.globals.showErrorSnackbar(this.lang.CM1047);
        return;
      }
      if (
        this.generalSettingsData.SurveyInstanceSince &&
        this.generalSettingsData.SurveyInstanceSince !== "-1" &&
        this.generalSettingsData.SurveyInstanceUntil &&
        this.generalSettingsData.SurveyInstanceUntil !== "-1" &&
        this.generalSettingsData.SurveyInstanceSince >
          this.generalSettingsData.SurveyInstanceUntil
      ) {
        this.globals.showErrorSnackbar(this.lang.CM1060);
        return;
      }

      let sendData = _.cloneDeep(this.generalSettingsData);

      sendData.SurveyInstanceIds = this.selectedCheckIds;
      if (
        this.surveyInstanceDescriptionMixed &&
        !sendData.SurveyInstanceDescription
      ) {
        sendData.SurveyInstanceDescription = "-1";
      }
      this.surveyInstanceDescriptionMixed = false;
      if (this.surveyInstanceInfoMixed && !sendData.SurveyInstanceInfo) {
        sendData.SurveyInstanceInfo = "-1";
      }
      this.surveyInstanceInfoMixed = false;

      if (!sendData.SurveyInstanceCustomReportingDate)
        delete sendData.SurveyInstanceCustomReportingDate;

      $.ajax({
        method: "PUT",
        url: "api/SurveyInstances/Properties?include=" + this.includeChecks,
        data: JSON.stringify(sendData),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: (data) => {
          if (data.Error) {
            this.globals.showErrorSnackbar(data.Error);
            console.error(data.Error);
            return;
          }
          this.globals.showSuccessSnackbar(this.lang.CM1048);
          this.$emit("dialogDataSaved");
          this.closeEditChecksDialog();
        },
        error: () => {
          console.error("Error on PUT in saveEditCheckDialogData()");
          this.globals.showErrorSnackbar(this.lang.CM1049);
        },
      });
    },
    getCheckSpecificData() {
      $.ajax({
        method: "POST",
        url: "api/SurveyInstances/Properties/DetailsList",
        data: JSON.stringify(this.selectedChecks),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: (data) => {
          if (!data || !data.length) {
            this.specificSettingsData.dataList = [];
            this.specificSettingsData.selectedCheck = {};
            return;
          }
          this.specificSettingsData.dataList = data;
          this.specificSettingsData.selectedCheck = data[0];

          this.fpDateOfVisit = flatpickr(
            "#inputDateOfVisitCheckMgmtEdit",
            this.globals.flatpickrDateConfig
          );
          this.fpTimeIn = flatpickr(
            "#inputTimeInCheckMgmtEdit",
            this.globals.flatpickrTimeConfig
          );
          this.fpTimeOut = flatpickr(
            "#inputTimeOutCheckMgmtEdit",
            this.globals.flatpickrTimeConfig
          );
        },
        error: () => {
          console.error("Error on POST in getCheckSpecificData()");
          this.globals.showErrorSnackbar(this.lang.CM1045);
        },
      });
    },
    saveCheckSpecificData() {
      for (let check of this.specificSettingsData.dataList) {
        for (let property in check) {
          if (!check[property]) delete check[property];
        }
      }

      $.ajax({
        method: "PUT",
        url: "api/SurveyInstances/Properties/DetailsList",
        data: JSON.stringify(this.specificSettingsData.dataList),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        error: () => {
          console.error("Error on PUT in saveCheckSpecificData()");
          this.globals.showErrorSnackbar(this.lang.CM1049);
        },
      });
    },
    getWavesOfProject() {
      if (!this.selectedProject) {
        this.wavesOfProject = [];
        return;
      }

      let wl = this.dataLists.waveList.find((w) => {
        return w.ProjectGuid === this.selectedProject;
      });
      if (wl && wl.Waves) this.wavesOfProject = wl.Waves;
      else this.wavesOfProject = [];
    },
    getScenariosOfWave() {
      if (!this.generalSettingsData.SurveyInstanceWaveGuid) {
        this.scenariosOfWave = [];
        return;
      }

      let sl = this.dataLists.scenarioList.find((s) => {
        return s.WaveGuid === this.generalSettingsData.SurveyInstanceWaveGuid;
      });
      if (sl && sl.Scenarios) this.scenariosOfWave = sl.Scenarios;
      else this.scenariosOfWave = [];
    },
    selectedLocationChanged() {
      if (
        !this.previousLocationGuid ||
        this.generalSettingsData.SurveyInstanceLocationGuid ===
          this.previousLocationGuid
      )
        return;

      this.globals.$off(
        "CheckManagementEditModalSelectedLocationChangedCloseDialog"
      );
      this.globals.$once(
        "CheckManagementEditModalSelectedLocationChangedCloseDialog",
        () => {
          if (this.previousLocationGuid)
            this.generalSettingsData.SurveyInstanceLocationGuid = this.previousLocationGuid;
        }
      );
      this.globals.$off(
        "CheckManagementEditModalSelectedLocationChangedYesConfirmation"
      );
      this.globals.$once(
        "CheckManagementEditModalSelectedLocationChangedYesConfirmation",
        () => {
          this.previousLocationGuid = "";
        }
      );

      this.globals.$emit("openGlobalConfirmationDialog", {
        initiator: "CheckManagementEditModalSelectedLocationChanged",
        confirmationTitle: this.lang.CM1030,
        colorRed: true,
        yesButtonText: this.lang.CM1031,
        noButtonText: this.lang.CM1032,
        htmlText: `<p><b>${this.lang.CM1033}</b></p>`,
      });
    },
    getLocationsOfSelectedClient() {
      $.ajax({
        method: "POST",
        url: `api/SurveyInstances/Locations/${this.selectedClient}`,
        success: (data) => {
          if (data[0]) {
            if (data[0].Locations)
              this.locationsOfSelectedClient = data[0].Locations;
            else this.locationsOfSelectedClient = [];
          }
        },
        error: () => {
          console.error("Error on POST in getLocationsOfSelectedClient()");
          this.globals.showErrorSnackbar("Location data access failed");
        },
      });
    },
    getProjectAttachments() {
      if (!this.selectedProject) {
        this.briefingAttachments = [];
        this.surveyAttachments = [];
        return;
      }
      let queryString = `/api/data/ProjectAttachments/${this.selectedProject}`;
      $.ajax({
        method: "GET",
        url: queryString,
        success: (data) => {
          if (data.length > 0) {
            this.briefingAttachments = data.filter(
              (d) => d.AttachmentType === "Briefing"
            );
            this.surveyAttachments = data.filter(
              (d) => d.AttachmentType === "Survey"
            );
          }
        },
        error: () => {
          console.error(
            "Project attachments data access failed in getProjectAttachments()"
          );
          this.globals.showErrorSnackbar(this.lang.CM1050);
        },
      });
    },
    openHtmlEditor() {
      this.globals.$emit("openHtmlEditorModal");
      this.globals.$emit("sendDataToHtmlEditorModal", {
        title: this.lang.CM1051,
        content: this.generalSettingsData.SurveyInstanceDescription,
      });
    },
  },
  watch: {
    showDialog(value) {
      if (value) this.openEditChecksDialog();
      else this.closeEditChecksDialog();
    },
    selectedClient(newValue) {
      if (newValue) this.$clientChanged = true;
    },
    "specificSettingsData.selectedCheck"(check) {
      if (this.fpDateOfVisit && !_.isEmpty(this.fpDateOfVisit))
        this.fpDateOfVisit.setDate(
          check.SurveyInstanceAnswerDateOfVisit,
          true,
          "Y-m-d"
        );
      if (this.fpTimeIn && !_.isEmpty(this.fpTimeIn))
        this.fpTimeIn.setDate(check.SurveyInstanceAnswerTimeIn, true, "H:i");
      if (this.fpTimeOut && !_.isEmpty(this.fpTimeOut))
        this.fpTimeOut.setDate(check.SurveyInstanceAnswerTimeOut, true, "H:i");
    },
    "generalSettingsData.SurveyInstanceWaveGuid"() {
      this.getScenariosOfWave();
    },
    "globals.selectedLanguage"() {
      this.languageStringsReceived = false;
      this.globals.getLanguageStrings(this, () => {
        this.languageStringsReceived = true;
      });
    },
  },
  props: [
    "dataLists",
    "selectedChecks",
    "selectedCheckIds",
    "selectedClient",
    "selectedProject",
    "includeChecks",
    "showDialog",
    "projectSelected",
  ],
  data() {
    // Global data inside the component is stored here
    return {
      checkData: {}, // The check data of the selected check is stored here
      generalSettingsData: {
        SurveyInstanceCustomReportingDate: "",
        SurveyInstanceExternalInterface: 0,
        SurveyInstanceExternalCustom: 0,
        SurveyInstanceQueryTool: 0,
        SurveyInstanceDashboard: 0,
        SurveyInstanceCheckExplorer: 0,
        SurveyInstanceAggregatedReport: 0,
        SurveyInstanceRawDataExports: 0,
        SurveyInstanceFrequencies: 0,
        SurveyInstanceMediaExplorer: 0,
        SurveyInstanceLocationGuid: "",
        SurveyInstanceScenarioGuid: "",
        SurveyInstanceWaveGuid: "",
        SurveyInstanceAssignedShopperGuid: "",
        SurveyInstanceAssignedLocalAgencyGuid: "",
        SurveyInstanceInfo: "",
      },
      surveyInstanceDescriptionMixed: false,
      surveyInstanceInfoMixed: false,
      specificSettingsData: {
        selectedCheck: {},
        dataList: [],
      },
      shopperFilter: {},
      shopperFilterDataDirty: false,
      scenarioList: [],
      wavesOfProject: [],
      scenariosOfWave: [],
      locationsOfSelectedClient: [],
      briefingAttachments: [],
      surveyAttachments: [],
      previousLocationGuid: "",
      fpCustomReportingDate: null,
      fpDateOfVisit: null,
      fpTimeIn: null,
      fpTimeOut: null,
      fpBegin: null,
      fpEnd: null,
      languageStringsReceived: false,
      lang: {
        CM1000: "Edit Checks",
        CM1001: "General Settings",
        CM1002: "PDF sent by Mail",
        CM1003: "External Interface",
        CM1004: "External Custom",
        CM1005: "Query Tool",
        CM1006: "Dashboard",
        CM1007: "Check Explorer",
        CM1008: "Aggregated Report",
        CM1009: "Raw Data Exports",
        CM1010: "Frequencies",
        CM1011: "Media Explorer",
        CM1012: "Type of Mail",
        CM1013: "Custom Reporting Date",
        CM1014: "Scenario",
        CM1015: "User",
        CM1016: "Agency",
        CM1017: "Check Specific Settings",
        CM1018: "Selected Checks",
        CM1019: "Date of Visit",
        CM1020: "Time In",
        CM1021: "Time Out",
        CM1022: "Memo Shopper",
        CM1023: "Memo Agency",
        CM1024: "Memo MSM",
        CM1025: "Cancel",
        CM1026: "Save",
        CM1027: "Check Description",
        CM1028: "Wave",
        CM1029: "Location",
        CM1030: "Location changed",
        CM1031: "Yes",
        CM1032: "No",
        CM1033:
          "ATTENTION: Changing the location may impact filters inside the check. Do you really want to change the location?",
        CM1034: "Briefing",
        CM1035: "Survey",
        CM1036: "Check type",
        CM1037: "Free offer",
        CM1038: "Manual assignment",
        CM1039: "Agency",
        CM1040: "Begin",
        CM1041: "End",
        CM1042: "Online",
        CM1043: "Location free",
        CM1044: "Edit offer description",
        CM1045: "Check property access failed",
        CM1046: "No agency selected",
        CM1047: "No user selected",
        CM1048: "Check property update successful",
        CM1049: "Check property update failed",
        CM1050: "Attachment data access failed",
        CM1051: "Offer description",
        CM1052: "Internal note",
        CM1053: "Shopper filter",
        CM1054: "Shopper filter request failed",
        CM1055: "Shopper filter update failed",
        CM1056: "Check Info",
        CM1057: "Difficulty",
        CM1058: "simple",
        CM1059: "difficult",
        CM1060: "End date before start date",
        CM1061: "Inherit from survey",
        CM1062: "Combined filters",
        CM1063: "OK",
        CM1064:
          "Due to the selection of multiple checks there are lots of possible filter combinations that could not be represented in this view. In this case an empty filter appears.",
        CM1065:
          "Nevertheless it‘s possible to define a new filter for all selected checks. Already existing filters will be overwritten.",
        CM1066: "Lead agency",
        CM1067: "Local agency",
        CM1068: "Shopper",
        CM1069: "Age",
        CM1070: "Gender",
        CM1071: "Car",
        CM1072: "Target segment",
        CM1073: "Target model",
      },
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#editChecksDialog .modal-dialog {
  transition: all 200ms ease;
}

#collapseEditChecksGeneral > .panel-body {
  text-align: left;
  padding-top: 20px !important;
}

.shopper-info {
  text-align: left;
  padding: 10px 10px 10px 20px;
  border: 2px solid lightgray;
  border-radius: 10px;
  margin: 10px 0 10px 20px;
}
#approvedShopperDetailsContainer {
  font-size: 12px;
  padding-left: 40px;
}

#checkListContainer td,
#checkListContainer th {
  width: 100%;
}

.btn-cb-edit-checks {
  width: 300px;
  text-align: left;
  padding: 10px;
  display: block;
  margin: 0 0 0 20px;
}
.btn-state {
  margin: 0;
  text-align: left;
  display: block;
  background-color: white !important;
}

.fg-general-settings-input {
  margin: 0 0 0 20px;
}

.form-group > label,
.form-group > div {
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// CheckManagementEditModal.vue?f8150fc4